import React from 'react';

const PasswordVisibilityIcon = ({ visible }) => {
  if (visible) {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M2.25 12s3.5-6.25 9.75-6.25S21.75 12 21.75 12 18.25 18.25 12 18.25 2.25 12 2.25 12Z" />
        <circle cx="12" cy="12" r="3.25" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M3 3l18 18" />
      <path d="M10.58 10.58A2 2 0 0 0 12 14a2 2 0 0 0 1.42-.58" />
      <path d="M9.88 5.92A9.86 9.86 0 0 1 12 5.75C18.25 5.75 21.75 12 21.75 12a18.57 18.57 0 0 1-2.54 3.2" />
      <path d="M6.6 7.55A18.85 18.85 0 0 0 2.25 12S5.75 18.25 12 18.25a9.92 9.92 0 0 0 4.1-.88" />
    </svg>
  );
};

export default PasswordVisibilityIcon;
